import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

function Failed(props) {
    return (
        <div className="col-sm-12">
            <div className="alert alert-danger alert-perso" role="alert">
                {props.message}
            </div>
        </div>
    );
}

export function Warning(props) {
    return (
        <div className="col-sm-12">
            <div className="alert alert-warning alert-perso" role="alert">
                {props.message}
            </div>
        </div>
    );
}

export function FailedLogin(props) {
    return (
        <div className="col-sm-12 error-center">
            <div className="alert alert-danger alert-perso" role="alert">
                {props.message}
            </div>
        </div>
    );
}


export default Failed;